import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Groups from "@/pages/Groups";
import Collaborators from "@/pages/Collaborators";
import CollaboratorDetail from "@/pages/CollaboratorDetail";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Tasks from "@/pages/Tasks";
import Waiting from "@/pages/Waiting";
import Analytics from "@/pages/Analytics";
import UsersPage from "@/pages/Users";
import PendingRegistrations from "@/pages/PendingRegistrations";
import Profile from "@/pages/Profile";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-screen grid place-items-center text-ink-muted">Učitavanje...</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/forgot-password" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
            <Route path="/reset-password" element={<PublicOnly><ResetPassword /></PublicOnly>} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/grupacije" element={<Groups />} />
              <Route path="/saradnici" element={<Collaborators />} />
              <Route path="/saradnici/:id" element={<CollaboratorDetail />} />
              <Route path="/projekti" element={<Projects />} />
              <Route path="/projekti/:id" element={<ProjectDetail />} />
              <Route path="/taskovi" element={<Tasks />} />
              <Route path="/cekam" element={<Waiting />} />
              <Route path="/analitika" element={<Analytics />} />
              <Route path="/korisnici" element={<UsersPage />} />
              <Route path="/zahtevi" element={<PendingRegistrations />} />
              <Route path="/profil" element={<Profile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
